export const API_URL = "http://";

let apiBaseUrl = "https://kumhomarinesvc.com/api/";
// let apiBaseUrl = "http://localhost:4500/"

export const getApiBaseUrl = () => {
    return apiBaseUrl;
};

export const setApiBaseUrl = (newUrl) => {
    apiBaseUrl = newUrl;
};
